module.exports = __webpack_public_path__ + "static/media/customer.a77c05f6.svg";